// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import socialSwiper from './components/socialResponsibility/socialSwiper.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

/*import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);*/

Vue.config.productionTip = false
Vue.use(VueAxios,axios);
Vue.component('sr-box',socialSwiper);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data(){
    return{
       baseUrl:'https://www.skledu.com'
      // baseUrl:'http://skl.bt.besn.net'
     // baseUrl:'http://127.0.0.1'
    }
  },
  router,
  components: {
  	App,
  	socialSwiper
  },
  template: '<App/>'
})


document.onclick = function(e){
  document.getElementById("navLinkBox").classList.remove('active');
  document.getElementById("navLinkBox").style.transition = "0.5s";
}

function fontSize(){
    var deviceWidth=document.documentElement.clientWidth>768?768:document.documentElement.clientWidth;
    document.documentElement.style.fontSize=(deviceWidth/25)+"px";
}
fontSize();


if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

}else{
   location.href="https://www.skledu.com";
}


var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?fca02645803fca1e4ce2e86c43c66add";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();



// WEBPACK FOOTER //
// ./src/main.js